import React, { useContext, useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { NotificationManager, ProfileDropdown } from "../components/header";
import { Button, Section, Box, Input } from "../components/elements";
import { DrawerContext } from "../context/Drawer";
import { ThemeContext } from "../context/Themes";
import data from "../data/master/header.json";
import { QuickActions } from "../components/header/QuickActions";
import {
  ADD_ACCOUNT_TRANSACTION,
  ADD_CLIENT_INCOME,
  ADD_EMPLOYEE_SALARY,
  ADD_USER_PAYMENT,
  ADD_VENDOR_PAYMENT,
  ADD_WEEKLY_WORKER_PAYMENT,
  ADD_WORK,
  ADD_WORKER_PAYMENT,
  CREATE_EXPENSE,
  CREATE_PURCHASE,
  CREATE_SUBCONTRACTOR_TRANSACTION,
  EDIT_BULK_WORK,
} from "../constants";
import { hasPermission } from "../utils/authUtils";
import { LOGO_FULL } from "../utils/image.constants";
import { Logo } from "../components";

const actionMenus = [
  {
    permissions: [ADD_WORK],
    path: "/add-work/entry",
    icon: "work_history",
    text: "Add Work",
  },
  {
    permissions: [EDIT_BULK_WORK],
    path: "/edit-work/bulk",
    icon: "timer",
    text: "Add Overtime",
  },
  {
    permissions: [CREATE_PURCHASE],
    path: "/vendor/purchase/add",
    icon: "shopping_cart",
    text: "Add Purchase",
  },
  {
    permissions: [CREATE_EXPENSE],
    path: `/expense/add?stayInPage=${true}`,
    icon: "paid",
    text: "Add Expense",
  },
  {
    permissions: [ADD_CLIENT_INCOME],
    path: "/add-income",
    icon: "add_circle",
    text: "Add Income",
  },
  {
    permissions: [
      ADD_WORKER_PAYMENT,
      ADD_EMPLOYEE_SALARY,
      ADD_VENDOR_PAYMENT,
      CREATE_SUBCONTRACTOR_TRANSACTION,
      ADD_USER_PAYMENT,
      ADD_ACCOUNT_TRANSACTION,
    ],
    path: "/transaction/add",
    icon: "remove_circle",
    text: "Cash Out",
  },
  {
    permissions: [ADD_WEEKLY_WORKER_PAYMENT],
    path: "/worker-payment/weekly",
    icon: "groups",
    text: "Weekly Payment",
  },
];

export function Header() {
  const navigate = useNavigate();
  const { drawer, toggleDrawer } = useContext(DrawerContext);
  const { theme, toggleTheme } = useContext(ThemeContext);
  const searchRef = useRef();
  const [scroll, setScroll] = useState("fixed");
  const [search, setSearch] = useState("");
  const [visibleActionMenus, setVisibleActionMenus] = useState([]);

  const { permissions, user } = useSelector((state) => state.user);

  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 0) setScroll("sticky");
    else setScroll("fixed");
  });

  document.addEventListener("mousedown", (event) => {
    if (!searchRef.current?.contains(event.target)) {
      setSearch("");
    }
  });

  useEffect(() => {
    const filteredMenus = actionMenus.filter((action) => hasPermission(action.permissions, permissions, "OR"));
    setVisibleActionMenus(filteredMenus);
  }, [permissions]);

  return (
    <Section as="header" className={`mc-header ${scroll}`}>
      <Box style={{ width: 250, height: 50 }}>
        <Logo src={LOGO_FULL} alt="Company Logo" href="/" name={" "} />
      </Box>
      <Box className="mc-header-group">
        <Box className="mc-header-left">
          <Button icon={data?.search.icon} className="mc-header-icon search" onClick={() => setSearch("show")} />
          <Button icon={drawer ? "menu_open" : "menu"} className="mc-header-icon toggle" onClick={toggleDrawer} />
        </Box>
        <Box className="mc-header-right">
          <QuickActions icon="add" dropdown={visibleActionMenus} />

          <Button
            icon={theme}
            title={data.theme.title}
            onClick={toggleTheme}
            className={`mc-header-icon ${data.theme.addClass}`}
          />

          <NotificationManager icon={data.notify.icon} onViewAll={() => navigate("/notification")} />

          <ProfileDropdown
            name={`Hello, ${user.firstName} ${user.lastName}`}
            image={data.profile.image}
            username={user.username}
            dropdown={[{ path: "/my-profile", icon: "person", text: "my profile" }]}
          />
        </Box>
      </Box>
    </Section>
  );
}
